"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerReducer = exports.ActionTypes = void 0;
var ActionTypes;
(function (ActionTypes) {
    ActionTypes[ActionTypes["SET_MESSAGES"] = 0] = "SET_MESSAGES";
})(ActionTypes = exports.ActionTypes || (exports.ActionTypes = {}));
const footerReducer = (state, action) => {
    const { type, value } = action;
    switch (type) {
        case ActionTypes.SET_MESSAGES: {
            if (!value || typeof value !== 'object') {
                return state;
            }
            const prevMessagesStr = JSON.stringify(state.messages);
            const valueStr = JSON.stringify(value);
            if (prevMessagesStr === valueStr) {
                return state;
            }
            const newState = Object.assign({}, state);
            newState.messages = value;
            return newState;
        }
        default: {
            return state;
        }
    }
};
exports.footerReducer = footerReducer;
//# sourceMappingURL=footerReducer.js.map